var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.508,
    height: 13.508,
    viewBox: "0 0 13.508 13.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21011",
    "data-name": "Path 21011",
    d: "M9.913,8.721A5.508,5.508,0,1,0,8.719,9.915l3.6,3.6,1.194-1.194-3.6-3.6Zm-4.425.568a3.8,3.8,0,1,1,3.8-3.8,3.8,3.8,0,0,1-3.8,3.8Z",
    transform: "translate(0 -0.002)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.1e710ba622b179993cb8bccc119eac27.svg";
export { ForwardRef as ReactComponent };